<!--begin::Authentication - -->
<div class="flex flex-col justify-center items-center h-screen">
  <!--begin::Content-->
  <div class="flex flex-col justify-center items-center text-center">
    <!--begin::Wrapper-->
    <div class="card lg:w-[650px] py-5">
      <div class="card-body py-15 py-lg-20">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
